import * as yup from "yup"
import dayjs from "dayjs";
import { ReportsRightLayout } from ".";
import { Grid, Skeleton, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { DayJsDatePicker } from "../onboarding/newDatePicker";
import { MFSubmitButton } from "../../lib/formik";
import { Location } from "history"
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { RootStateType } from "../../redux-store/reducers";
import { useState } from "react";
import { getCustomerTransactionHistoryReport } from "../../redux-store/actions/reports";
import { reportDownload } from "../Reports/report-utils";
import { CONTENT_TYPE } from "../../utils/constant";
import MFSelectField from "../../lib/formik/SelectField";

// const downloadOptions = [
//   { key: 'PDF', value: 'pdf' },
//   { key: 'Excel', value: 'excel' },
// ]

// const TransactionStatement = ({
//   location
// }: {
//   location: Location<{ investorId: string; investorName: string }>
// }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();
//   const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
//   const history = useHistory();
//   const currentDate = dayjs();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
//   const [dates1, setDates1] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));


//   const onSubmit = async (values: any) => {
//     try {
//       const { fromDate, toDate } = values;
//       const FromDate = `${new Date(fromDate).getDate().toString().padStart(2, '0')}/${(new Date(fromDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(fromDate).getFullYear()}`;
//       const ToDate = `${new Date(toDate).getDate().toString().padStart(2, '0')}/${(new Date(toDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(toDate).getFullYear()}`;
//       if (investorId) {
//         setLoading(true)
//         const res = await dispatch(
//           getInvestorReports({
//             reportName: 'TransactionStatement',
//             // clientId: [replaceLetterOWithW(investorId) || ''],
//             clientId: [investorId || ''],
//             fromDate: FromDate,
//             toDate: ToDate,
//           })
//         );
//         setLoading(false)
//         downloadMultipleFiles(res);
//         enqueueSnackbar('File(s) downloaded successfully.', {
//           variant: 'success',
//           autoHideDuration: 3000,
//         });
//       }
//       setDates(dayjs(currentDate).format("YYYY-MM-DD"));
//       setDates1(dayjs(currentDate).format("YYYY-MM-DD"));
//     } catch (e) {
//       console.error((e as Error).message);
//     }
//   };

//   return (
//     <ReportsRightLayout>
//       <Typography
//         variant='h2'
//         sx={{
//           color: 'text.primary',
//           lineHeight: '25px',
//           letterSpacing: '0.01px',
//           mb: '40px',
//         }}>
//         Transaction Statement
//       </Typography>
//       <Formik
//         validationSchema={validationSchemaTransactionStatement}
//         initialValues={{
//           fromDate: new Date(),
//           toDate: new Date(),
//         }}
//         onSubmit={onSubmit}>
//         {({ values, setFieldValue }) => (
//           <Form>

//             {/* <ReportSectionContainer>
//               <Typography
//                 sx={{
//                   fontSize: '14px',
//                   fontWeight: 400,
//                   lineHeight: '22px',
//                   letterSpacing: '0.01em',
//                   pt: 1,
//                   pb: 1,
//                 }}>
//                 Choose duration of statement -
//               </Typography>
//               <Stack
//               >
//                 <LocalizationProvider dateAdapter={AdapterDayjs}
//                 >

//                   <DatePicker
//                     sx={{
//                       marginBottom: "30px"
//                     }}
//                     label="From Date"
//                     value={dayjs(dates)}
//                     maxDate={dayjs(currentDate)}

//                     onChange={(date: any) => {
//                       setDates(date.format("YYYY-MM-DD"))
//                       setFieldValue('fromDate', date)
//                     }
//                     }
//                   />

//                 </LocalizationProvider>

//                 <LocalizationProvider dateAdapter={AdapterDayjs}>

//                   <DatePicker
//                     label="TO Date"
//                     value={dayjs(dates1)}
//                     maxDate={dayjs(currentDate)}

//                     onChange={(date: any) => {
//                       setDates1(date.format("YYYY-MM-DD"))
//                       setFieldValue('toDate', date)
//                     }
//                     }
//                   />

//                 </LocalizationProvider>
//               </Stack>
//             </ReportSectionContainer>
//             <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
//               <MFSubmitButton
//                 label="Download"
//                 loadingEnable={loading}
//               // disabled={selectedFamilyMembers[0] === 'overall-family'}
//               />
//             </Stack> */}


//             <Grid container rowSpacing={4} >
//               <Grid item container columnSpacing={3}>
//                 <Grid item xs={12} lg={6}>
//                   <TextDatePicker
//                     inputLabelStyles={{
//                       transform: 'unset',
//                       fontSize: 14,
//                       fontWeight: 500,
//                       color: `${theme.palette.common.black}B3`
//                     }}
//                     name={'#'}
//                     placeholder='From Date'
//                     label="From Date"
//                     value={dayjs(dates).format('DD/MM/YYYY')}
//                     maxDate={new Date()}
//                     onSelect={(date: any) =>
//                       setDates(date.format("YYYY-MM-DD"))
//                     }
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={6}>
//                   <TextDatePicker
//                     inputLabelStyles={{
//                       transform: 'unset',
//                       fontSize: 14,
//                       fontWeight: 500,
//                       color: `${theme.palette.common.black}B3`
//                     }}
//                     name={'#'}
//                     placeholder='To Date'
//                     label="To Date"
//                     value={dayjs(dates1).format('DD/MM/YYYY')}
//                     maxDate={new Date()}
//                     onSelect={(date: any) =>
//                       setDates(date.format("YYYY-MM-DD"))
//                     }
//                   />
//                 </Grid>
//               </Grid>
//               <Grid item container columnSpacing={3}>
//                 <Grid item xs={12} lg={6}>

//                 </Grid>
//                 <Grid item xs={12} lg={6}>
//                   <MFSubmitButton
//                     label="Download"
//                     loadingEnable={loading}
//                   />
//                 </Grid>
//               </Grid>

//             </Grid>

//           </Form>
//         )}
//       </Formik>
//     </ReportsRightLayout>
//   );
// };



const TransactionStatement = ({
  location,
  handleSideSectionDisabled
}: {
  location: Location<{ investorId: string; investorName: string }>;
  handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element => {
  const dispatch = useDispatch()

  const { enqueueSnackbar } = useSnackbar();

  const [isDownloading, setDownloading] = useState<boolean>(false)

  const { iwappRmId = "", investorClientId = "" } = useSelector((state: RootStateType) => state.id);

  const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);


  const todayDate = new Date();
  const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");

  const initialValues = {
    selectedFromDate: formattedBusinessDate,
    selectedToDate: formattedBusinessDate,
    downloadOption: '',

  }

  const validationSchema = yup.object().shape({
    selectedFromDate: yup
      .date()
      .required('From Date is required')
      .typeError('From Date is required')
      .min(new Date("1950-01-01"), "From Date should not be less than 01/01/1950")
      .max(formattedBusinessDate, "From Date should not be greater than system's date")
      .test('fromDateTest', 'From Date cannot be greater than To Date', function (value) {
        const { selectedToDate } = this.parent;
        return !selectedToDate || !value || value <= selectedToDate;
      }),
    selectedToDate: yup
      .date()
      .required('To Date is required')
      .typeError('To Date is required')
      .min(new Date("1950-01-01"), "To Date should not be less than 01/01/1950")
      .max(formattedBusinessDate, "To Date should not be greater than system's date")
      .test('toDateTest', 'To Date cannot be less than From Date', function (value) {
        const { selectedFromDate } = this.parent;
        return !selectedFromDate || !value || value >= selectedFromDate;
      }),
    // downloadOption: yup.string().required('Please select download option')
  })
  const handleSubmit = async ({
    selectedFromDate,
    selectedToDate,
    downloadOption
  }: {
    selectedFromDate: string;
    selectedToDate: string;
    downloadOption: string
  }) => {
    try {
      setDownloading(true)
      handleSideSectionDisabled(true)

      const payload = {
        clientCode: `${investorClientId}`,
        rmId: `${iwappRmId}`,
        start: dayjs(selectedFromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        end: dayjs(selectedToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        // isPDF: (downloadOption ?? "").toLowerCase() === 'pdf' ? true : false,
        isPDF: true
      }

      const response = await (dispatch(getCustomerTransactionHistoryReport(payload)) as unknown as Promise<any>)

      if (response.type) {
        enqueueSnackbar('File downloaded successfully.', {
          variant: 'success',
          autoHideDuration: 2000,
        });

        reportDownload(response as unknown as Blob, `TransactionStatement.${response.type === CONTENT_TYPE.PDF ? 'pdf' : 'xlsx'}`);

      } else {
        enqueueSnackbar('File download failed!!', {
          variant: 'error',
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setDownloading(false)
      handleSideSectionDisabled(false)
    }

  }

  return (
    <ReportsRightLayout>
      <Typography
        variant='h2'
        sx={{
          color: 'text.primary',
          lineHeight: '25px',
          letterSpacing: '0.01px',
          mb: '40px',
        }}>
        Transaction Statement
      </Typography>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Grid container rowSpacing={4} >
              <Grid item container columnSpacing={3}>
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <DayJsDatePicker
                    id=""
                    name='selectedFromDate'
                    label="From Date"
                    maxDate={new Date(formattedBusinessDate)}
                    disabled={isDownloading}
                    currentDate={formattedBusinessDate}
                  />}
                </Grid>
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <DayJsDatePicker
                    id=""
                    name='selectedToDate'
                    label="To Date"
                    maxDate={new Date(formattedBusinessDate)}
                    minDate={new Date(values.selectedFromDate)}
                    disabled={isDownloading}
                    currentDate={formattedBusinessDate}
                  />}
                </Grid>
                {/* <Grid item xs={12} lg={6}>
                  {(isNavbarInfoLoading) && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {(!isNavbarInfoLoading) &&
                    <MFSelectField
                      name={'downloadOption'}
                      label="Select Download Option"
                      items={downloadOptions}
                      value={values.downloadOption}
                      onChange={(e) => {
                        setFieldValue('downloadOption', e.target.value);
                      }}
                      disabled={isDownloading}
                    />}
                </Grid> */}

              </Grid>
              <Grid item container columnSpacing={3} justifyContent="flex-end">
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <MFSubmitButton
                    label="Download"
                    loadingEnable={isDownloading}
                  />}
                </Grid>
              </Grid>

            </Grid>

          </Form>
        )}
      </Formik>
    </ReportsRightLayout >
  )
}

export default TransactionStatement;
